var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useRef, useState, useEffect } from "react";
import { imageGalleryStyles } from "./imageGalleryStyles";
export function ImageGallery(_a) {
    var imagesInfoArray = _a.imagesInfoArray, _b = _a.columnCount, columnCount = _b === void 0 ? "auto" : _b, _c = _a.columnWidth, columnWidth = _c === void 0 ? 230 : _c, _d = _a.gapSize, gapSize = _d === void 0 ? 24 : _d;
    var _e = useState(""), imageSrc = _e[0], setImageSrc = _e[1];
    var _f = useState(1), slideNumber = _f[0], setSlideNumber = _f[1];
    var _g = useState(false), showModalControls = _g[0], setShowModalControls = _g[1];
    var _h = useState(false), fullscreen = _h[0], setFullscreen = _h[1];
    var dialogRef = useRef(null);
    var lightboxRef = useRef(null);
    var galleryContainerStyle = imageGalleryStyles(columnCount, columnWidth, gapSize).galleryContainerStyle;
    var imageBtnStyle = imageGalleryStyles().imageBtnStyle;
    var imageContainerStyle = imageGalleryStyles(undefined, undefined, gapSize).imageContainerStyle;
    var imageStyle = imageGalleryStyles().imageStyle;
    var imageCaptionStyle = imageGalleryStyles().imageCaptionStyle;
    var modalContainerStyle = imageGalleryStyles().modalContainerStyle;
    var modalSlideNumberStyle = imageGalleryStyles().modalSlideNumberStyle;
    var modalToolbarStyle = imageGalleryStyles().modalToolbarStyle;
    var modalToolbarBtnStyle = imageGalleryStyles().modalToolbarBtnStyle;
    var modalSlideShowSectionStyle = imageGalleryStyles().modalSlideShowSectionStyle;
    var modalImageStyle = imageGalleryStyles().modalImageStyle;
    var modalSlideBtnStyle = imageGalleryStyles().modalSlideBtnStyle;
    function handleImageContainerMouseEnter(e) {
        var figcaption = e.currentTarget.querySelector("figcaption");
        figcaption && (figcaption.style.opacity = "1");
    }
    function handleImageContainerMouseLeave(e) {
        var figcaption = e.currentTarget.querySelector("figcaption");
        figcaption && (figcaption.style.opacity = "0");
    }
    function openLightboxOnSlide(imgSrc, number) {
        var _a;
        setImageSrc(imgSrc);
        setSlideNumber(number);
        (_a = dialogRef.current) === null || _a === void 0 ? void 0 : _a.showModal();
    }
    function changeSlide(directionNumber) {
        var totalImages = imagesInfoArray.length;
        var newSlideNumber = slideNumber + directionNumber;
        newSlideNumber < 1 && (newSlideNumber = totalImages);
        newSlideNumber > totalImages && (newSlideNumber = 1);
        if (newSlideNumber <= totalImages && newSlideNumber > 0) {
            setSlideNumber(newSlideNumber);
            setImageSrc(imagesInfoArray[newSlideNumber - 1].src);
        }
    }
    function switchFullScreen(on) {
        var _a;
        if (on) {
            (_a = lightboxRef.current) === null || _a === void 0 ? void 0 : _a.requestFullscreen().catch(function (error) {
                alert("Error while attempting to switch into fullscreen mode: ".concat(error.message, " (").concat(error.name, ")"));
            });
        }
        if (!on) {
            document.exitFullscreen().catch(function (error) { return console.error(error); });
        }
    }
    function handleKeyDownOnModal(e) {
        e.key === "ArrowLeft" && changeSlide(-1);
        e.key === "ArrowRight" && changeSlide(1);
        e.key === "f" && fullscreen && switchFullScreen(false);
        e.key === "f" && !fullscreen && switchFullScreen(true);
    }
    function exitFullScreenAndDialog() {
        var _a;
        fullscreen && switchFullScreen(false);
        (_a = dialogRef.current) === null || _a === void 0 ? void 0 : _a.close();
    }
    function SvgElement(pathElement) {
        return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20", fill: "currentColor", viewBox: "0 0 16 16" }, pathElement));
    }
    useEffect(function () {
        function handleFullscreenChange() {
            var _a;
            setFullscreen(Boolean(document.fullscreenElement));
            (_a = lightboxRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
        document.addEventListener("fullscreenchange", handleFullscreenChange);
        return function () {
            return document.removeEventListener("fullscreenchange", handleFullscreenChange);
        };
    }, []);
    useEffect(function () {
        var _a, _b;
        ((_a = dialogRef.current) === null || _a === void 0 ? void 0 : _a.open) &&
            (document.documentElement.style.overflow = "hidden");
        !((_b = dialogRef.current) === null || _b === void 0 ? void 0 : _b.open) && (document.documentElement.style.overflow = "");
    });
    var imageElementsArray = imagesInfoArray.map(function (item, index) { return (React.createElement("button", { type: "button", style: imageBtnStyle, key: crypto.randomUUID(), onKeyDown: function (e) {
            return e.key === "Enter" && openLightboxOnSlide(item.src, index + 1);
        } },
        React.createElement("figure", { style: imageContainerStyle, onMouseEnter: function (e) { return handleImageContainerMouseEnter(e); }, onMouseLeave: function (e) { return handleImageContainerMouseLeave(e); } },
            React.createElement("img", { alt: item.alt, src: item.src, onClick: function () { return openLightboxOnSlide(item.src, index + 1); }, style: imageStyle }),
            item.caption ? (React.createElement("figcaption", { style: imageCaptionStyle }, item.caption)) : ("")))); });
    var lightBoxElement = (React.createElement("dialog", { ref: dialogRef, style: { margin: "auto" } },
        React.createElement("article", { autoFocus: true, tabIndex: -1, ref: lightboxRef, style: modalContainerStyle, onKeyDown: function (e) { return handleKeyDownOnModal(e); }, onMouseEnter: function () { return setShowModalControls(true); }, onMouseLeave: function () { return setShowModalControls(false); }, onClick: function (e) {
                return e.target.tagName === "SECTION" &&
                    exitFullScreenAndDialog();
            } },
            React.createElement("span", { style: __assign({ opacity: showModalControls ? 1 : 0 }, modalSlideNumberStyle) }, "".concat(slideNumber, " / ").concat(imagesInfoArray.length)),
            React.createElement("span", { style: __assign({ opacity: showModalControls ? 1 : 0 }, modalToolbarStyle) },
                React.createElement("button", { type: "button", "aria-label": "Go full screen (Keyboard shortcut f)", style: __assign({ display: fullscreen ? "none" : "block" }, modalToolbarBtnStyle), title: "Go full screen (f)", onClick: function () { return switchFullScreen(true); } }, SvgElement(React.createElement("path", { d: "M1.5 1a.5.5 0 0 0-.5.5v4a.5.5 0 0 1-1 0v-4A1.5 1.5 0 0 1 1.5 0h4a.5.5 0 0 1 0 1zM10 .5a.5.5 0 0 1 .5-.5h4A1.5 1.5 0 0 1 16 1.5v4a.5.5 0 0 1-1 0v-4a.5.5 0 0 0-.5-.5h-4a.5.5 0 0 1-.5-.5M.5 10a.5.5 0 0 1 .5.5v4a.5.5 0 0 0 .5.5h4a.5.5 0 0 1 0 1h-4A1.5 1.5 0 0 1 0 14.5v-4a.5.5 0 0 1 .5-.5m15 0a.5.5 0 0 1 .5.5v4a1.5 1.5 0 0 1-1.5 1.5h-4a.5.5 0 0 1 0-1h4a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 1 .5-.5" }))),
                React.createElement("button", { type: "button", "aria-label": "Exit full screen", style: __assign({ display: fullscreen ? "block" : "none" }, modalToolbarBtnStyle), title: "Exit full screen", onClick: function () { return switchFullScreen(false); } }, SvgElement(React.createElement("path", { d: "M5.5 0a.5.5 0 0 1 .5.5v4A1.5 1.5 0 0 1 4.5 6h-4a.5.5 0 0 1 0-1h4a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 1 .5-.5m5 0a.5.5 0 0 1 .5.5v4a.5.5 0 0 0 .5.5h4a.5.5 0 0 1 0 1h-4A1.5 1.5 0 0 1 10 4.5v-4a.5.5 0 0 1 .5-.5M0 10.5a.5.5 0 0 1 .5-.5h4A1.5 1.5 0 0 1 6 11.5v4a.5.5 0 0 1-1 0v-4a.5.5 0 0 0-.5-.5h-4a.5.5 0 0 1-.5-.5m10 1a1.5 1.5 0 0 1 1.5-1.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 0-.5.5v4a.5.5 0 0 1-1 0z" }))),
                React.createElement("button", { type: "button", "aria-label": "Close lightbox", style: modalToolbarBtnStyle, title: "Close lightbox", onClick: function () { return exitFullScreenAndDialog(); } }, SvgElement(React.createElement("path", { d: "M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" })))),
            React.createElement("section", { style: modalSlideShowSectionStyle },
                React.createElement("button", { type: "button", "aria-label": "Previous image", style: __assign({ opacity: showModalControls ? 1 : 0, left: 0 }, modalSlideBtnStyle), title: "Previous image", onClick: function () { return changeSlide(-1); } }, SvgElement(React.createElement("path", { fillRule: "evenodd", d: "M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8" }))),
                React.createElement("img", { src: imageSrc, alt: imagesInfoArray[slideNumber - 1].alt, style: modalImageStyle }),
                React.createElement("button", { type: "button", "aria-label": "Next image", style: __assign({ opacity: showModalControls ? 1 : 0, right: 0 }, modalSlideBtnStyle), title: "Next image", onClick: function () { return changeSlide(1); } }, SvgElement(React.createElement("path", { fillRule: "evenodd", d: "M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" })))))));
    return (React.createElement("div", { style: galleryContainerStyle },
        imageElementsArray,
        lightBoxElement));
}
